// @flow

import * as kv from 'idb-keyval';
import {
  storageItemLoading,
  storageItemLoaded,
} from 'docs/data/storage/StorageReducer';

import type {Dispatcher} from 'docs/data';
import type {StorageEvent} from 'docs/data/storage/StorageReducer';

export const loadItem = (
  dispatch: Dispatcher<StorageEvent>,
  database: any,
) => async (key: string, defaultValue: any) => {
  if (database === null) {
    return;
  }

  dispatch(storageItemLoading(key));

  const value = await kv.get(key, database);

  dispatch(storageItemLoaded(key, value));

  return value;
};
